import React, { useContext } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import styles from './Table.module.scss'
import { SERVING_STATUS_COLOR } from '~/constants'
import { ThemeContext } from '~/theme/ThemeProvider'
import { capitalize } from '~/utils/string'
import { useTranslation } from 'react-i18next'

const cx = classNames.bind(styles)

const CustomTable = ({ data, tableWidth }) => {
  const { currentThemeObject } = useContext(ThemeContext)
  const { t } = useTranslation()
  const getColor = (status) => {
    const colorKey = SERVING_STATUS_COLOR[status]
    const themeColor = currentThemeObject[colorKey]
    return themeColor
  }

  const getTextStatus = (status) => {
    if (status === 'pending') return 'titles.pending'
    if (status === 'cancelled') return 'titles.cancelled'
    if (status === 'confirmed') return 'titles.confirmed'
    return ''
  }

  return (
    <TableContainer component={Paper} style={{ width: tableWidth }} className={cx('container')}>
      <Table>
        <TableHead>
          <TableRow
            sx={{
              '& th': {
                borderTop: '1px solid',
                borderBottom: '1px solid',
              },
            }}>
            <TableCell width={160} className={cx('txt_header_table')}>
              {t('titles.quantity')}
            </TableCell>
            <TableCell className={cx('txt_header_table')} width={160}>
              {t('titles.item_table')}
            </TableCell>
            <TableCell className={cx('txt_header_table')} width={160}>
              {t('titles.status_table')}
            </TableCell>
            <TableCell className={cx('txt_header_table')} width={160}>
              {t('titles.price_table')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                '& th': {
                  borderTop: '1px solid',
                  borderBottom: '1px solid',
                },
              }}>
              <TableCell className={cx('txt_item_title')}>{row.quantity}</TableCell>
              <TableCell className={cx('txt_item_title')}>{row.item}</TableCell>
              <TableCell
                className={cx('txt_item_title')}
                style={{
                  color: getColor(row.status),
                  fontWeight: 600,
                }}>
                {capitalize(t(getTextStatus(row.status)))}
              </TableCell>
              <TableCell className={cx('txt_item_title')}>{row.price}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
CustomTable.propTypes = {
  data: PropTypes.array,
  tableWidth: PropTypes.number,
}
export default CustomTable
